// extracted by mini-css-extract-plugin
export var pagination = "ParagraphPopularTopics-module--pagination--db6be";
export var swiper = "ParagraphPopularTopics-module--swiper--a2c98";
export var swiperwrapper = "ParagraphPopularTopics-module--swiperwrapper--8291d";
export var title = "ParagraphPopularTopics-module--title--c7cb4";
export var wrapperinner = "ParagraphPopularTopics-module--wrapperinner--f4101";